import { getAuthToken } from '../context/AuthContext';

/**
 * Drop-in reemplazo de `fetch` que agrega el header Authorization si hay
 * sesión. Antes de activar `authMiddleware` en el backend (todas las
 * rutas de negocio, no solo tiempo/notificaciones) la mayoría de los
 * componentes llamaban a `fetch` directo sin token — funcionaba porque
 * esas rutas estaban abiertas. Ahora todas requieren token, así que todo
 * el código que llama a la API de negocio tiene que pasar por acá.
 */
export const apiFetch = (input: string, init: RequestInit = {}): Promise<Response> => {
    const token = getAuthToken();
    const headers = new Headers(init.headers);
    if (token && !headers.has('Authorization')) {
        headers.set('Authorization', `Bearer ${token}`);
    }
    return fetch(input, { ...init, headers });
};
